import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { OutlineInputControl } from '__components/Inputs/InputControl';
import { KizenTypography } from '__app/typography';
import Loader from '__components/Kizen/Loader';
import { KizenRangeInput } from '__pages/Settings/pages/Team/PermissionGroupModal/components/KizenRangeInput';
import Notice from 'components/Kizen/Notice';

export const StyledLoader = styled(Loader)`
  ${({ loading }) =>
    loading &&
    css`
      padding-top: 5% !important;
    `}
`;

export const StyledModelMessage = styled(KizenTypography)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const StyledPromptMessage = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
`;

export const StyledPromptUsage = styled.div`
  display: flex;
  justify-content: space-between;
  > p {
    margin: 0;
    font-style: italic;
  }
  margin-top: 12px;
  margin-bottom: 20px;
`;

export const StyledOutlineInputControl = styled(OutlineInputControl)`
  & label {
    margin-bottom: 0;
  }
`;

const SIZE = 14;
const LABEL_WIDTH = 180;

export const StyledRangeInput = styled(KizenRangeInput)`
  &&& {
    display: block;
    margin: 0 auto;
    width: calc(100% - ${LABEL_WIDTH - SIZE}px);

    [data-reach-slider-input] {
      margin: 0;
      width: 100%;
      max-width: none;
      height: initial;
      cursor: pointer;
      border-radius: ${SIZE / 2}px;
      background-color: var(--color-background-medium);
    }
    [data-reach-slider-handle] {
      border-width: 2px;
      border-color: var(--color-button-secondary-hover);
      z-index: 0;
    }
    [data-reach-slider-track] {
      height: ${SIZE}px;
      margin: 0 ${SIZE / 2}px;
      background: initial;
    }
    [data-reach-slider-track-highlight] {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      background-color: var(--color-button-secondary-hover);
    }
    [data-reach-slider-marker] {
      border-radius: 50%;
      > * {
        // Don't show step number
        display: none;
      }
      // These styles are only for the first marker
      height: ${SIZE}px;
      width: ${SIZE}px;
      background-color: var(--color-button-secondary-hover);
      ~ [data-reach-slider-marker] {
        // And these styles are for all other markers
        height: 4px;
        width: 4px;
        background-color: var(--color-background-white);
      }
    }
  }
`;

export const StyledRangeLabels = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  & > * {
    width: ${LABEL_WIDTH}px;
    text-align: center;
    margin-top: 10px;
  }
`;

export const StyledNotice = styled(Notice)`
  height: fit-content;
  margin-top: 26px;
`;
